import Sidebar from '../components/Sidebar';
import { ReactNode } from 'react';
import { isPresenterMode as isUrlPresenterMode } from '../utils/isPresenterMode';
import { usePlanSync } from '../entitlements/usePlanSync';
import { useTenantSync } from '../entitlements/useTenantSync';
import { UpsellProvider } from '../entitlements/upsell/UpsellProvider';
import { ChecklistAnnouncer } from '../onboarding/checklist/ChecklistAnnouncer';

interface Props {
  children: ReactNode;
}

const PrivateApp = ({ children }: Props) => {
  // Publishes the team's plan and tenant for `useEntitlement`; first component inside the
  // team context, and until the tenant answers no upsell register is safe on both tenants.
  usePlanSync();
  useTenantSync();

  // Only the ?presenter_mode=true toggle hides the sidebar; Read-Only users keep it and rely on
  // the Sidebar's own RBAC to filter admin entries.
  const hideSidebarForDemo = isUrlPresenterMode();
  return (
    <UpsellProvider>
      {/* The assistant drawer publishes its width here rather than covering the page. This is
          the wrapper and not <body> because Radix's scroll lock rewrites body padding/margin. */}
      <div
        data-app-shell
        style={{
          minHeight: '100vh',
          paddingRight: 'var(--app-assistant-inset, 0px)',
          // The same gesture as a sidebar collapse (components/Sidebar/styles/Sidebar.ts).
          transition: 'padding-right 0.25s ease-in-out',
        }}
      >
        {!hideSidebarForDemo && <Sidebar />}
        {children}
        {/* Lives here so the last message outlives the Sidebar checklist's unmount — a live
            region removed in the same commit says nothing. */}
        <ChecklistAnnouncer />
      </div>
    </UpsellProvider>
  );
};

export default PrivateApp;
